import { SVGProps } from 'react';

const IdCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 10h2m-2 4h2M6.17 15a3 3 0 0 1 5.66 0M11 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2"
    />
  </svg>
);
export default IdCard;
